module.exports = __webpack_public_path__ + "static/media/end-call.8759d60c.svg";